import React from 'react';
import styles from "./adLocationMap.scss";
import { getIconUrl } from '../../../services/asset';
import { ZOOM_HINT_STATE, useZoomHint } from '../../AdFormPage/LocationSelector/hooks/useZoomHint';
import { getWindowWidth, isMobileScreen } from '../../../services/utils';
import { useOpenLayerMap } from './hooks/useOpenLayerMap';


const EMPTY_ID = "00000000-0000-0000-0000-000000000000"

type Props = {
  adSummary: any;
}

const MAP_ELEMENT_NAME = "ad-location-map"

const AdLocationMap = ({ adSummary }: Props) => {
  const isMobile = isMobileScreen(getWindowWidth());
  const zoomHint = useZoomHint(MAP_ELEMENT_NAME)

  const { handleReturnToLocation } = useOpenLayerMap(adSummary)

  const shouldShowMap = [adSummary.countryId, adSummary.countyId, adSummary.cityId, adSummary.settlementId].every(v => v && v !== EMPTY_ID)

  return shouldShowMap ? (
    <div style={{ position: 'relative' }}>
      <div id={MAP_ELEMENT_NAME} className={styles.adLocationMap}>
        <button
          className={styles.returnToLocationButton}
          onClick={handleReturnToLocation}
          title="Vrati na lokaciju"
        >
          <img src={getIconUrl("focus_pin.svg")} style={{ marginRight: 0 }} />
        </button>
      </div>
      <div className={styles.zoomHint} style={{ opacity: zoomHint === ZOOM_HINT_STATE.shown ? 1 : 0 }}>
        {isMobile ? "Koristi dva prsta za zumiranje karte" : "Pritisni CTRL + scroll za zumiranje karte"}
      </div>
    </div >
  ) : null;
};

export default AdLocationMap;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdLocationMap/AdLocationMap.tsx